import { cn } from '../../../lib/utils.ts'
import { type IllustrationProps } from '../illustration-base.tsx'
import { illustrationVariants } from '../illustration.variants.ts'

export function MessageIllustration({
  size = 'big',
  className,
  'aria-label': ariaLabel = 'Message',
  'aria-hidden': ariaHidden,
  ...rest
}: IllustrationProps): React.ReactElement {
  return (
    <svg
      viewBox="0 0 80 80"
      role="img"
      aria-label={ariaHidden === true ? undefined : ariaLabel}
      aria-hidden={ariaHidden}
      xmlns="http://www.w3.org/2000/svg"
      className={cn(illustrationVariants({ size }), className)}
      {...rest}
    >
      <>
        <defs>
          <linearGradient
            id="message-paint0_linear_16538_41536"
            x1={36.745}
            x2={59.98}
            y1={42.128}
            y2={58.951}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#226322" />
            <stop offset={0.07} stopColor="#327232" />
            <stop offset={0.29} stopColor="#62A062" />
            <stop offset={0.5} stopColor="#89C589" />
            <stop offset={0.7} stopColor="#A4DFA4" />
            <stop offset={0.87} stopColor="#B5EFB5" />
            <stop offset={1} stopColor="#BBF5BB" />
          </linearGradient>
          <linearGradient
            id="message-paint1_linear_16538_41536"
            x1={12.567}
            x2={43.342}
            y1={68.097}
            y2={21.48}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#CCAE93" />
            <stop offset={0.09} stopColor="#D9C3AF" />
            <stop offset={0.19} stopColor="#E4D4C7" />
            <stop offset={0.31} stopColor="#ECE1D9" />
            <stop offset={0.44} stopColor="#F2EBE6" />
            <stop offset={0.62} stopColor="#F6F0ED" />
            <stop offset={1} stopColor="#F7F2F0" />
          </linearGradient>
        </defs>
        <g id="message-Insurance=-, Generic=Message, Size=Small">
          <g id="message-Group 214">
            <path
              id="message-Vector"
              fill="url(#message-paint0_linear_16538_41536)"
              d="M38.565 49.06v16.448c0 2.666 2.156 4.321 4.822 3.694l5.176 3.256c.328.2.828-.145.828-.573v-4.094l13.275-3.102c2.665-.618 4.822-3.284 4.822-5.95V42.293c0-2.666-2.157-4.321-4.822-3.694l-19.27 4.503c-2.666.619-4.822 3.285-4.822 5.95z"
            />
            <path
              id="message-Vector_2"
              fill="#58B558"
              d="M48.753 72.722a.72.72 0 0 1-.385-.11l-5.102-3.191c-1.365.282-2.648.027-3.619-.737-.961-.764-1.493-1.927-1.493-3.291V48.951c0-2.801 2.29-5.602 5.103-6.256l19.401-4.502c1.42-.327 2.748-.072 3.747.71.962.763 1.493 1.927 1.493 3.291v16.441c0 2.8-2.29 5.602-5.102 6.256L49.678 67.93v3.837a.98.98 0 0 1-.513.837.9.9 0 0 1-.421.109zm-5.432-3.956a.4.4 0 0 1 .174.046l5.212 3.255s.11 0 .156-.018a.33.33 0 0 0 .183-.282v-4.092c0-.146.1-.273.247-.31l13.365-3.1c2.538-.591 4.608-3.12 4.608-5.638v-16.44c0-1.165-.449-2.156-1.255-2.792-.843-.664-1.988-.873-3.206-.591l-19.402 4.5c-2.537.592-4.608 3.12-4.608 5.639v16.44c0 1.164.45 2.156 1.255 2.792.843.664 1.98.873 3.207.591h.073z"
            />
            <path
              id="message-Vector_3"
              fill="#58B558"
              d="M42.574 49.542a.32.32 0 0 1-.31-.238.306.306 0 0 1 .237-.37l20.904-4.718c.164-.035.346.062.383.23a.306.306 0 0 1-.237.37l-20.904 4.717h-.073z"
            />
            <path
              id="message-Vector_4"
              fill="#58B558"
              d="M42.574 54.055a.32.32 0 0 1-.31-.238.306.306 0 0 1 .237-.37l20.904-4.718c.164-.035.346.062.383.23a.306.306 0 0 1-.237.37l-20.904 4.717h-.073z"
            />
            <path
              id="message-Vector_5"
              fill="#58B558"
              d="M42.574 58.568a.32.32 0 0 1-.31-.238.306.306 0 0 1 .237-.37l20.904-4.718c.164-.035.346.062.383.23a.306.306 0 0 1-.237.37l-20.904 4.717h-.073z"
            />
            <path
              id="message-Vector_6"
              fill="#58B558"
              d="M42.573 63.286a.32.32 0 0 1-.309-.254c-.036-.179.064-.358.236-.395l10.856-2.626a.32.32 0 0 1 .38.245c.037.179-.063.358-.235.395l-10.856 2.625h-.072z"
            />
            <path
              id="message-Vector_7"
              fill="url(#message-paint1_linear_16538_41536)"
              d="M8.41 39.513v21.413c0 3.467 2.802 5.62 6.258 4.808l6.722 4.243c.418.264 1.073-.183 1.073-.74V63.91l17.228-4.033c3.456-.812 6.258-4.279 6.258-7.737V30.727c0-3.467-2.802-5.62-6.258-4.808l-25.014 5.857c-3.456.812-6.258 4.28-6.258 7.737z"
            />
            <path
              id="message-Vector_8"
              fill="#000"
              d="M21.63 70.456a.9.9 0 0 1-.447-.127l-6.637-4.166c-1.756.374-3.401.046-4.645-.939C8.676 64.25 8 62.754 8 61.014V39.622c0-3.6 2.935-7.21 6.536-8.049l25.14-5.851c1.81-.42 3.502-.1 4.782.911 1.224.976 1.901 2.47 1.901 4.211v21.392c0 3.6-2.934 7.21-6.536 8.048l-17.068 3.974v5.068c0 .401-.247.802-.622 1.003a1.04 1.04 0 0 1-.493.136zm-7.03-4.949a.4.4 0 0 1 .174.045l6.756 4.239c.11.064.256 0 .292-.028.147-.082.293-.246.293-.446v-5.323c0-.146.1-.273.247-.31l17.314-4.029c3.328-.774 6.043-4.101 6.043-7.419V30.844c0-1.54-.594-2.862-1.664-3.71-1.115-.883-2.623-1.157-4.232-.783l-25.14 5.851c-3.328.775-6.043 4.102-6.043 7.42v21.392c0 1.54.594 2.861 1.664 3.71 1.115.883 2.614 1.157 4.232.783h.074z"
            />
            <path
              id="message-Vector_9"
              fill="#CCAE92"
              d="M13.65 40.312a.32.32 0 0 1-.31-.247.317.317 0 0 1 .237-.383l27.059-6.337a.32.32 0 0 1 .382.237.317.317 0 0 1-.237.383l-27.059 6.337h-.072z"
            />
            <path
              id="message-Vector_10"
              fill="#CCAE92"
              d="M13.65 46.055a.32.32 0 0 1-.31-.246.317.317 0 0 1 .237-.383l27.059-6.338c.164-.036.345.064.382.237a.317.317 0 0 1-.237.383l-27.059 6.338h-.072z"
            />
            <path
              id="message-Vector_11"
              fill="#CCAE92"
              d="M13.65 52.004a.32.32 0 0 1-.073-.63l27.059-6.337a.32.32 0 0 1 .382.237.32.32 0 0 1-.237.384l-27.059 6.337h-.072z"
            />
            <path
              id="message-Vector_12"
              fill="#CCAE92"
              d="M13.65 57.953a.32.32 0 0 1-.31-.256c-.036-.18.064-.36.237-.398l14.136-3.441a.32.32 0 0 1 .382.246c.036.18-.064.36-.237.398l-14.135 3.441h-.073z"
            />
            <path
              id="message-Vector_13"
              fill="#000"
              d="m68.134 8.62-13.806 3.25c-1.905.448-3.456 2.37-3.456 4.293v11.89c0 1.923 1.542 3.122 3.456 2.673l9.153-2.16v4.156l4.653-5.254c1.905-.45 3.456-2.371 3.456-4.294v-11.89c0-1.923-1.542-3.122-3.456-2.673z"
            />
            <path
              id="message-Vector_14"
              fill="#000"
              d="M63.488 32.927s-.074 0-.11-.019a.31.31 0 0 1-.202-.301v-3.748l-8.842 2.057c-1.044.247-2.032.055-2.765-.53-.714-.567-1.107-1.435-1.107-2.45V16.063c0-2.057 1.675-4.122 3.735-4.607l13.931-3.245c1.044-.246 2.023-.054 2.765.53.714.567 1.107 1.436 1.107 2.45v11.873c0 2.03-1.62 4.059-3.634 4.58l-4.622 5.173a.3.3 0 0 1-.238.11zm0-4.79a.32.32 0 0 1 .2.073.34.34 0 0 1 .12.247v3.318l4.137-4.625a.4.4 0 0 1 .165-.1c1.785-.42 3.24-2.203 3.24-3.976V11.2c0-.813-.31-1.508-.87-1.947-.585-.466-1.372-.612-2.224-.41l-13.931 3.244c-1.785.42-3.24 2.203-3.24 3.976v11.873c0 .814.31 1.5.869 1.947.586.466 1.373.613 2.224.411l9.236-2.157z"
            />
            <path
              id="message-Vector_15"
              fill="#F7F2F0"
              d="M55.083 25.747a.316.316 0 0 1-.306-.24.31.31 0 0 1 .234-.375l8.81-2.044a.313.313 0 0 1 .377.232.31.31 0 0 1-.234.375l-8.81 2.043h-.072z"
            />
            <path
              id="message-Vector_16"
              fill="#F7F2F0"
              d="M55.087 21.645a.32.32 0 0 1-.31-.239.307.307 0 0 1 .237-.37l12.698-2.871c.174-.035.347.062.383.23a.307.307 0 0 1-.237.37l-12.698 2.87h-.073z"
            />
            <path
              id="message-Vector_17"
              fill="#F7F2F0"
              d="M55.087 17.337a.32.32 0 0 1-.31-.238.307.307 0 0 1 .237-.371l12.698-2.87c.174-.036.347.061.383.229a.307.307 0 0 1-.237.37L55.16 17.329h-.073z"
            />
          </g>
        </g>
      </>
    </svg>
  )
}
